export default {
  loggedIn(state) {
    return !!state.activeUser
  },
}
